<!-- this file should turn semi-colon in prettierrc.js to true -->
<template>
  <div v-if="!isLoadingPage">
    <div
      class="buttonValidate2"
      v-if="detailData != null && !detailData.is_checked"
    >
      <v-btn
        style="font-weight: bold; width: 100%"
        color="success"
        type="submit"
        @click="verifiedDocument"
      >
        Validate
        <v-icon
          small
          color="white"
          style="position: relative; top: 0px; left: 3px"
        >
          mdi-check-circle-outline
        </v-icon>
      </v-btn>
    </div>
    <v-card
      elevation="0"
      style="
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: 60px;
        background: white;
        z-index: 5;
      "
    >
      <v-card-title>
        <p
          class="text-h6 font-weight-bold text-center text-uppercase"
          style="margin: auto; z-index: 5"
        >
          Detail Surat Jalan
          <v-tooltip bottom color="grey">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                x-small
                text
                icon
                color="grey darken-2"
                @click="getDataFromApi"
                style="position: relative; top: -3px"
              >
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>refresh page</span>
          </v-tooltip>
        </p>
        <p
          v-if="detailData"
          style="
            position: absolute;
            bottom: -20px;
            left: 13px;
            font-weight: bold;
            padding-left: 3px;
            font-size: 14px;
            z-index: 5;
          "
        >
          {{ detailData.odoo_order_no }}
        </p>
      </v-card-title>
      <div class="actionButton">
        <v-btn
          type="button"
          rounded
          elevation="0"
          class="font-weight-bold ma-2"
          @click.prevent="closeDetail"
          outlined
          x-small
        >
          <v-icon x-small>mdi-chevron-left</v-icon>
          Kembali
        </v-btn>

        <div
          class="buttonValidate1"
          v-if="detailData != null && !detailData.is_checked"
        >
          <v-btn
            @click="verifiedDocument"
            style="font-weight: bold; min-width: 120px"
            small
            color="success"
            type="submit"
          >
            Validate
            <v-icon
              x-small
              color="white"
              style="position: relative; top: 0px; left: 5px"
            >
              mdi-check-circle-outline
            </v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
    <v-card elevation="0" v-if="detailData != null">
      <div v-if="detailData != null && detailData.is_checked" class="ribbon">
        CHECKED
      </div>
      <v-card-text>
        <p
          style="
            position: absolute;
            top: -20px;
            left: 10px;
            font-weight: bold;
            padding-left: 4px;
            font-size: 12px;
          "
        >
          Order Date: {{ detailData.order_date }} | Schedule Date:
          {{ convertDate(detailData.scheduled_date) }}
        </p>
        <v-form
          ref="entryForm"
          readonly
          @submit.prevent
          style="margin-top: 10px; padding: 10px"
        >
          <v-row no-gutters>
            <v-col cols="11">
              <v-row>
                <v-col cols="12" md="8" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Company
                  </p>
                  <v-text-field
                    v-model="detailData.company_name"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Status
                  </p>
                  <v-text-field
                    v-model="detailData.state"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Customer Name
                  </p>
                  <v-text-field
                    :value="`(${detailData.customer_code}) ${detailData.customer_name}`"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="8" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Delivery Address
                  </p>
                  <v-text-field
                    :value="detailData.customer_address"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Source Location
                  </p>
                  <v-text-field
                    v-model="detailData.source_location"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Sale Order
                  </p>
                  <v-text-field
                    v-model="detailData.sale_order"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Partner Location
                  </p>
                  <v-text-field
                    v-model="detailData.loading_from_company_name"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Vehicle Name
                  </p>
                  <v-text-field
                    v-model="detailData.vehicle_name"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Vehicle Model
                  </p>
                  <v-text-field
                    v-model="detailData.vehicle_model"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    License Plate
                  </p>
                  <v-text-field
                    v-model="detailData.license_plate"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Driver Name
                  </p>
                  <v-text-field
                    v-model="detailData.driver_name"
                    dense
                    style="height: 20px"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Carrier Type
                  </p>
                  <v-text-field
                    v-model="detailData.carrier_type"
                    dense
                    style="height: 20px"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-card v-if="!isLoadingPage">
          <v-tabs
            v-model="tab"
            background-color="#ccdbdc"
            slider-color="primary"
          >
            <v-tab v-for="item in tabItems" :key="item.tab">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="item in tabItems"
              :key="item.tab"
              style="padding: 10px"
            >
              <div style="min-height: 70vh; padding: 0; margin-bottom: 30px">
                <div v-if="item.tab == 'List Product'">
                  <v-card elevation="3" class="mt-5">
                    <v-data-table
                      :headers="tableHeaders"
                      :items="detailData.order_details"
                      :items-per-page="10"
                      :loading="isLoadingPage"
                      :search="searchItem"
                      :custom-filter="customSearch"
                      dense
                      fixed-header
                      item-key="id"
                      mobile-breakpoint="0"
                      height="50vh"
                      style="cursor: pointer"
                    >
                      <template v-slot:top>
                        <div
                          style="
                            border: thin solid rgba(0, 0, 0, 0.12);
                            cursor: auto;
                            padding: 0 15px;
                            height: 75px;
                            display: flex;
                            overflow: hidden;
                          "
                        >
                          <div
                            style="
                              width: 260px;
                              position: relative;
                              top: 15px;
                              margin: 0 15px 0 5px;
                              font-size: 12px;
                              height: 45px;
                            "
                          >
                            <v-text-field
                              v-model="searchItem"
                              label="Cari barang"
                              outlined
                              dense
                            ></v-text-field>
                          </div>
                        </div>
                      </template>
                      <template v-slot:[`item.no`]="{ index }">
                        <div style="width: 35px; font-size: 12px">
                          {{ index + 1 }}
                        </div>
                      </template>
                      <template v-slot:[`item.product_name`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              style="
                                text-align: left;
                                width: 250px;
                                font-size: 12px;
                                padding: 0;
                              "
                            >
                              {{
                                `${
                                  item.product_code !== null
                                    ? '(' + item.product_code + ')'
                                    : ''
                                } ${item.product_name}`
                              }}
                            </div>
                          </template>
                          <span>
                            {{
                              `${
                                item.product_code !== null
                                  ? '(' + item.product_code + ')'
                                  : ''
                              } ${item.product_name}`
                            }}</span
                          >
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.uom_name`]="{ item }">
                        <div style="font-size: 12px">
                          {{ item.uom_name }}
                        </div>
                      </template>
                      <template v-slot:[`item.qty`]="{ item }">
                        <div style="font-size: 12px">
                          {{ item.qty || 0 }}
                        </div>
                      </template>
                      <template v-slot:[`item.qty_demand`]="{ item }">
                        <div style="font-size: 12px">
                          {{ item.qty_demand || 0 }}
                        </div>
                      </template>
                      <template v-slot:[`item.qty_done`]="{ item }">
                        <div style="font-size: 12px">
                          {{ item.qty_done || 0 }}
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <div
          v-else
          class="d-flex justify-center align-center"
          style="height: 150px"
        >
          <v-progress-circular :size="80" :width="5" color="blue" indeterminate
            >Loading...</v-progress-circular
          >
        </div>
      </v-card-text>
    </v-card>
    <v-card
      v-else
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      DATA NOT FOUND
    </v-card>
    <div style="position: fixed; bottom: 10px; right: 10px; z-index: 3">
      <BarcodeScanner @loadPage="getDataFromApi" />
    </div>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'deliveryOrderDetail',
  components: {
    BarcodeScanner: () => import('../../home/components/BarcodeScanner.vue')
  },
  data: () => ({
    config: require('../../../services/config.json')[env],
    build: process.env.VUE_APP_BUILD_TYPE,
    oAuthApi: buildType.apiURL('oauth'),
    odooApi: buildType.apiURL('odoo'),
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null
    },
    searchItem: '',
    detailData: null,
    isLoadingPage: true,
    tab: null
  }),

  async mounted() {
    this.getDataFromApi()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    // , 'getDropdownPlant', 'getShiftSettingPageQuery'
    ...mapGetters(['getUserProfile']),
    tabItems() {
      const arr = [
        { tab: 'List Product', content: '' }
        // { tab: 'Laporan Leading', content: '' },
        // { tab: 'Approval', content: '' }
      ]
      return arr
    },
    tableHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left'
          // sortable: true,
        },
        // {
        //   text: 'Code',
        //   value: 'product_code',
        //   align: 'left',
        //   // sortable: true,
        //   sortable: false
        // },
        {
          text: 'Product',
          value: 'product_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Qty',
          value: 'qty',
          align: 'left',
          sortable: false
        },
        {
          text: 'Uom',
          value: 'uom_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Demand',
          value: 'qty_demand',
          align: 'left',
          sortable: false
        },
        {
          text: 'Done',
          value: 'qty_done',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    }
  },
  watch: {},
  methods: {
    // ...mapActions(['menu_access', 'getMenuId']),
    // ...mapMutations([
    //   // /*'setOvertimePageQuery'*/
    // ]),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, pText, isInput) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            input: isInput ? 'textarea' : null,
            inputLabel:
              'Tolong isi keterangan pada kolom dibawah sebelum submit',
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    customSearch(value, search, item) {
      return Object.values(item).some(
        (v) => v && v.toString().toLowerCase().includes(search)
      )
    },
    async getDataFromApi() {
      this.isLoadingPage = true
      // this.panel = []
      // this.locationTab = null
      // this.locationTabItems = []
      const url = `${this.odooApi}stock_picking/detail?do_no=${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('Detaill >>>', res)
          if (res.data.status_code == '00') {
            this.isLoadingPage = false
            this.detailData = res.data.data
          } else {
            this.isLoadingPage = false
            // this.showMsgDialog('error', res.data.status_msg, false)
          }
          return null
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
          return null
        })
    },
    verifiedDocument() {
      this.showMsgDialog(
        'question',
        'Tandai dokumen bahwa sudah sesuai ?',
        true,
        undefined,
        false
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.isLoadingPage = true
          const form = {
            do_no: decodeURIComponent(this.$route.params.id),
            // id: this.$route.params.id,
            is_checked: true
          }
          axios
            .post(`${this.odooApi}stock_picking/checked`, form)
            .then(async (res) => {
              this.isLoadingPage = false
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.isLoadingPage = false
            })
        }
      })
    },
    closeDetail() {
      this.detailData = null
      setTimeout(() => {
        this.$router.push('/')
      }, 300)
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    setSparator(val) {
      if (val != undefined) {
        if (val != null) {
          return val.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, '.')
        }
      }
      return '0'
    },
    statusColor(val) {
      switch (val) {
        case 'draft':
          return 'grey'
        case 'waiting_approval':
          return 'orange'
        case 'confirmed':
          return 'blue'
        case 'assigned':
          return 'blue'
        case 'done':
          return 'green'
        default:
          return 'grey'
      }
    }
  }
}
</script>
<style lang="scss">
.ribbon {
  width: 250px;
  background: green; /* Warna merah */
  color: #fff;
  text-align: center;
  line-height: 45px;
  font-weight: bold;
  font-size: 18px;
  position: absolute;
  right: -70px;
  top: 10px;
  transform: rotate(45deg);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.2);
}
.buttonValidate2 {
  display: none;
}
.buttonValidate1 {
  display: flex;
  position: absolute;
  top: 34px;
  right: 15px;
}
.actionButton {
  position: relative;
  display: flex;
  // width: 400px;
}
#formTemplateList {
  position: relative;
  .form-template-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .form-template-list-toolbar2 {
      display: none;
    }
  }
}
.result-5r {
  padding: 5px;
  table {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
  }

  thead {
    background-color: #f7f7f7;
  }

  th,
  td {
    padding: 6px 12px;
  }

  td:first-child {
    font-weight: bold;
    text-align: left;
  }
}
@media (max-width: 768px) {
  #formTemplateList {
    .form-template-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .form-template-list-toolbar2 {
        display: block;
      }
    }
  }
}
@media (max-width: 500px) {
  .buttonValidate1 {
    display: none;
  }
  .buttonValidate2 {
    display: flex;
    position: fixed;
    z-index: 5;
    bottom: 10px;
    left: 0;
    width: 100%;
    padding: 0 10px;
    background-color: rgba(255, 255, 255, 0.7);
  }
}
</style>
